import { render, staticRenderFns } from "./singlelist.vue?vue&type=template&id=d72a25de&scoped=true&"
import script from "./singlelist.vue?vue&type=script&lang=js&"
export * from "./singlelist.vue?vue&type=script&lang=js&"
import style0 from "./singlelist.vue?vue&type=style&index=0&id=d72a25de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a25de",
  null
  
)

export default component.exports